import { render, staticRenderFns } from "./TabButton.vue?vue&type=template&id=22912090&scoped=true&"
import script from "./TabButton.vue?vue&type=script&lang=js&"
export * from "./TabButton.vue?vue&type=script&lang=js&"
import style0 from "./TabButton.vue?vue&type=style&index=0&id=22912090&scoped=true&lang=scss&"
import style1 from "./TabButton.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22912090",
  null
  
)

export default component.exports